export interface IFileUpload {
    name: string,
    size: number,
    content: string
}
//Copied from DS library as I cannot access to these types
export enum FileStatusEnum {
    DEFAULT = "default",
    DRAGGING = "dragging",
    UPLOADING = "uploading",
    UPLOADED = "uploaded",
    DISABLED = "disabled",
    ERROR = "error"
}
export type FileStatusType = `${FileStatusEnum}`;
